/* eslint-disable @typescript-eslint/no-empty-function */
'use client'

import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime'

export default async function goToSearch(
  router: AppRouterInstance,
  queryString: string
) {
  const { push, refresh } = router

  const path = `/search?name=${queryString}`

  push(path)
  refresh()
}
